// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "TU_API_KEY",
  authDomain: "b-sites-bd.firebaseapp.com",
  databaseURL: "https://b-sites-bd-default-rtdb.firebaseio.com",
  projectId: "b-sites-bd",
  storageBucket: "b-sites-bd.appspot.com",
  messagingSenderId: "TU_SENDER_ID",
  appId: "TU_APP_ID"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
